import {
  InformationBox,
  MuiBox,
  MuiGrid,
  MuiTypography,
} from "../../../../components";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { BulkEditHeaderWrapper } from "./BulkEditHeader.style";

interface BulkEditHeaderProps {
  subTitle?: string;
}

export const BulkEditHeader = ({ subTitle }: BulkEditHeaderProps) => {
  const { pageTitle } = useSiteCore();

  return (
    <BulkEditHeaderWrapper>
      <MuiGrid container>
        <MuiGrid
          size={{ sm: 6, xs: 12 }}
          className="header-left"
          data-testid="bulk-transfer-header"
        >
          <InformationBox title={pageTitle}>
            {subTitle && (
              <MuiBox className="subtitle">
                <MuiTypography variant="h3SemiBold" component="h3" >
                  {subTitle}
                </MuiTypography>
              </MuiBox>
            )}
          </InformationBox>
        </MuiGrid>
      </MuiGrid>
    </BulkEditHeaderWrapper>
  );
};
